import React from 'react';
import { Helmet } from 'react-helmet-async';
import baseUrl from '../config/SEOConfig';


const SEO = ({ title, description, keywords,path }) => {
   const canonicalUrl = `${baseUrl}${path || ''}`;
  console.log("SEO Props:", { title, description, keywords,canonicalUrl });
  return (
   <Helmet>
      <title>{title}</title>
      <meta name="description" content={description || ''} />
      <meta name="keywords" content={keywords || ''} />
       <meta name="robots" content="index, follow" />
       <link rel="canonical" href={canonicalUrl} />
    </Helmet>
  );
};


export default SEO;
